module.exports = __webpack_public_path__ + "static/media/115.89bd9935.jpg";